import * as React from "react";
export const SuppressHotjarComponent = (props: { children?: React.ReactNode }) => (
  <div data-hj-suppress="">{props.children}</div>
);
